import { Snackbar, styled } from '@ori-ui/mui';
const topNavHeightStyle = 'var(--top-nav-height, 0)';
export const SnackbarError = styled(Snackbar)(({
  theme
}) => ({
  transform: `translate(0, ${topNavHeightStyle})`,
  transition: `transform var(--top-nav-height-animation), 0.3s ease-in-out`,
  [theme.breakpoints.up('sm')]: {
    top: '8px'
  }
}));